import React, { useState, useEffect } from 'react';
import InventoryForm from './InventoryForm';
import { Column, Row } from 'simple-flexbox';
import {
    Paper,
    makeStyles,
    TableBody,
    TableRow,
    TableCell,
    Toolbar,
    InputAdornment,
} from '@material-ui/core';
import useTable from '../../../utilities/useTable';
import { ToastContainer } from 'react-toastify';
import StatComponent from '../../stat-page/StatComponent';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import Controls from '../../../controls/Controls';
import { Search } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import Popup from '../../../utilities/Popup';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CloseIcon from '@material-ui/icons/Close';
import Notification from '../../../utilities/Notification';
import ConfirmDialog from '../../../utilities/ConfirmDialog';
import AddInventoryForm from './AddInventoryForm';
import AddInventoryCount from './AddInventoryCount';
import InventoryCorrection from './InventoryCorrection';
import ReportData from "../../stat-page/StatComponent";

const useStyles = makeStyles((theme) => ({
    pageContent: {
        margin: theme.spacing(1),
        padding: theme.spacing(3),
    },
    searchInput: {
        width: '75%',
    },
    newButton: {
        position: 'absolute',
        right: '10px',
    },
}));

const headCells = [
    { id: 'locationAddress', label: 'Quantity Sold' },
    { id: 'locationName', label: 'Product Name' },
    { id: 'contactName', label: 'Gross Profit' },
    { id: 'contactName', label: 'Net Sales Value' },
    { id: 'contactName', label: 'Cost Sold' },
];


export function SalesReport({
    locations,
    LoadSalesReport,
    profitabilityReport,
    roles,
    userDrop,
    salesReport
}) {

    function VerifyRole() {
        var role = roles;
        if (role[0] == 'Inventory Manager' || role[0] == 'App Owner') {
            return true;
        }
    }
    const classes = useStyles();
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });
    useEffect(() => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        today = yyyy + '/' + mm + '/' + dd;
        var payload = {
            startDate: today,
            endDate: today,
            userId: userId,
        };
        localStorage.setItem('startDate', payload.startDate);
        localStorage.setItem('endDate', payload.endDate);
        console.log(67676)
        LoadSalesReport(payload);
    }, []);
    const [openPopup, setOpenPopup] = useState(false);
    const [userId, setUserId] = useState(0);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [addOpenPopup, setAddOpenPopup] = useState(false);
    const [correctionOpenPopup, setCorrectionOpenPopup] = useState(false);
    const [notify, setNotify] = useState({
        isOpen: false,
        message: '',
        type: '',
    });
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: '',
        subTitle: '',
    });
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
        useTable(profitabilityReport, headCells, filterFn);
    function handleInputChange(e) {
        const { name, value } = e.target;
        setUserId(value);

        var payload = {
            startDate: localStorage.getItem('startDate'),
            endDate: localStorage.getItem('endDate'),
            userId: value,
        };
        LoadSalesReport(payload);
    }

    const handleInputStartDateChange = (e, v) => {

        setUserId(userId);
        if (e.target == null) {
            var dd = String(v.getDate()).padStart(2, '0');
            var mm = String(v.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = v.getFullYear();
            v = yyyy + '/' + mm + '/' + dd;
            localStorage.setItem('startDate', v);
            setStartDate(v);
        } else {
            localStorage.setItem('startDate', e.target.value);
            setStartDate(e.target.value);
        }

        var payload = {
            startDate: localStorage.getItem('startDate'),
            endDate: localStorage.getItem('endDate'),
            userId: userId,
        };

        LoadSalesReport(payload);
    };
    const handleInputEndDateChange = (e, v) => {
        if (e.target == null) {
            var dd = String(v.getDate()).padStart(2, '0');
            var mm = String(v.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = v.getFullYear();
            v = yyyy + '/' + mm + '/' + dd;
            localStorage.setItem('endDate', v);
            setEndDate(v);
        } else {
            localStorage.setItem('endDate', e.target.value);
            setEndDate(e.target.value);
        }
        var payload = {
            startDate: localStorage.getItem('startDate'),
            endDate: localStorage.getItem('endDate'),
            userId: userId,
        };
        LoadSalesReport(payload);
    };

    useEffect(() => {
        return () => { };
    }, []);


    return (
        <>
            <div
                className="container"

            >
                <div style={{ marginTop: '-3rem' }}>
                    <Column flexGrow={1}>
                        <ToastContainer />
                        <div
                            className="mt-5"
                            style={{ position: 'relative', left: '2.5rem' }}
                        >
                        </div>

                        <Paper className={classes.pageContent}>
                            <h4>
                                {' '}
                                <strong>Sales Report</strong>
                            </h4>
                            <div
                                className="container row p-0 m-0 w-50"
                                style={{ position: 'absolute', right: '6rem' }}
                            >
                                <div
                                    style={{ display: 'flex', justifyContent: 'space-between' }}
                                >
                                    {' '}
                                    <Controls.Select
                                        name="userId"
                                        label="Users"
                                        placeholder="Users"
                                        onChange={handleInputChange}
                                        options={userDrop}
                                    />
                                    <Controls.Input
                                        name="date"
                                        type="date"
                                        value={localStorage.getItem("startDate") || ''}
                                        onChange={handleInputStartDateChange}
                                        style={{ marginRight: "1rem" }}
                                    />{' '}
                                    <Controls.Input
                                        name="date"
                                        type="date"
                                        value={localStorage.getItem("endDate") || ''}
                                        onChange={handleInputEndDateChange}
                                    />{' '}
                                </div>

                                <div className="col"></div>

                            </div>

                            {/* Displayed Cards */}
                            <div className="row container" style={{ marginTop: '8rem' }}>
                                <div className="col-md-4 col-sm-6 p-2">
                                    <div className="bg-white homeCard mx-auto text-center homeCard">
                                        <div className="homeCard-child">
                                            <p className="text-primary m-0"> <strong> Net Sales</strong> </p>
                                            <p className="m-0 pt-2"> <strong> {salesReport.netSales} </strong></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 p-2">
                                    <div className="bg-white mx-auto text-center homeCard">
                                        <div className="homeCard-child">
                                            <p className="m-0 text-primary"> <strong> Discounts</strong> </p>
                                            <p className="m-0 pt-2"> <strong> {salesReport.discount}</strong></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 p-2">
                                    <div className="bg-white mx-auto text-center homeCard">
                                        <div className="homeCard-child">
                                            <p className="m-0 text-primary"> <strong> Refund</strong> </p>
                                            <p className="m-0 pt-2"> <strong> {salesReport.refund = 0}</strong></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End of Displayed Cards */}


                        </Paper>

                        <Notification notify={notify} setNotify={setNotify} />
                        <ConfirmDialog
                            confirmDialog={confirmDialog}
                            setConfirmDialog={setConfirmDialog}
                        />
                    </Column>
                </div>
            </div>
        </>
    );
}

function mapStateToProps(state) {
   
    return {
        salesReport: state.inventoryReducer.salesReport,
        roles:state.persistReducer.roles,
        userDrop:state.persistReducer.userDrop
    };
}
const mapDispatchToProps = (dispatch) => ({
    LoadSalesReport(payload) {
        dispatch({ type: 'LOAD_SALES_REPORT', payload });
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SalesReport);
